/* eslint-disable camelcase, no-invalid-this */
import { html } from 'lit-element';
import { ifDefined } from 'lit-html/directives/if-defined';


export const render_textarea = function() {
  const {
    value,
    disabled,
    placeholder,
    required,
    label,
    rows,
    hideResize
  } = this;
  return html`
        <fc-textarea 
            value="${ifDefined(value)}"
            label="${ifDefined(placeholder)}" 
            ?required="${required}" 
            ?disabled="${disabled}" 
            .hideResize="${hideResize !== undefined ? hideResize : true}"
            name="${ifDefined(label)}"
            @keyup="${this.setValue}"
            rows="${rows ? rows : '2'}">
        </fc-textarea>
    `;
};
